<app-auth-layout>
  <h2>Restablecer contraseña</h2>
      <h6>Primero, introduce el código enviado a tu correo electrónico</h6>
      <br>
      <div class="row">
        <div class="col">
          <div class="email-input">
            <input type="email" value="+543472439748" readonly>
          </div>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col">
          <app-input-otp #otpInput [length]="6" (otpComplete)="onOtpComplete($event)"></app-input-otp>
        </div>
      </div>
</app-auth-layout>
